export function vaccineReceiptPayload(form, key) {
    return {
        request_key: key, presentation_id: Number(form.presentation_id), stock_id: Number(form.stock_id),
        lot: String(form.lot || '').trim(), expires_on: form.expires_on, units_received: Number(form.units_received),
        supplier_id: form.supplier_id ? Number(form.supplier_id) : null,
        supplier_reference: String(form.supplier_reference || '').trim() || null,
    }
}
